module.exports = __webpack_public_path__ + "img/60.0db1de7d.jpg";